var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarMenu)?_c('div',[_vm._m(0),_c('b-list-group',[_c('relacao-contratacoes-entregas'),_c('relacao-reabertura-entregas'),_c('relacao-cancelamento-entregas'),_c('relacao-contratacoes-entregas-gestor'),_c('relacao-contratacoes-entregas-gerente')],1)],1):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"heading-1"},[_c('span',[_vm._v("SGF")])])
}]

export { render, staticRenderFns }